const sanitiseKimQuestion = (question: string) => {
  // Remove the @[...](...)  format and keep only the content inside square brackets, wrapped in quotes
  return question.replace(/@\[(.*?)\]\(.*?\)/g, '"$1"');
};

export { sanitiseKimQuestion };
